import { rem } from 'polished'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { track } from 'analytics/analytics'
import { tripDocumentEvent } from 'analytics/snowplow/events'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { useTripDocumentUrl } from 'tripPlanner/hooks/api/documents'

const StyledBodyText = styled(BodyText)`
  position: absolute;
  top: 0;
  padding: ${rem(24)};
`

const StyledImage = styled.img`
  position: absolute;
  padding-top: ${rem(72)}; // space for the header content
  padding-bottom: ${rem(12)};
  max-height: calc(100vh);
  object-fit: contain;
`

interface Props {
  documentKey: string
  filename: string
}

function DocumentImageView({ documentKey, filename }: Props) {
  const { data: presignedUrl } = useTripDocumentUrl({ documentKey })

  useEffect(() => {
    track('upload-trip-document', tripDocumentEvent('view'))
  }, [documentKey])

  return (
    <>
      {!presignedUrl && <LoadingIndicator />}
      {presignedUrl && (
        <>
          <StyledBodyText variant="medium" colour="neutral-eight">
            {filename}
          </StyledBodyText>
          <StyledImage src={presignedUrl} alt="Document" width="100%" />
        </>
      )}
    </>
  )
}

export default DocumentImageView
